/* tslint:disable */
/* eslint-disable */

/**
 * MessageType
 */
export enum LogMessageType {
  Comment = 'COMMENT',
  Email = 'EMAIL',
  Notification = 'NOTIFICATION',
  Sdtposition = 'SDTPOSITION',
  System = 'SYSTEM'
}
